import {useContext, useCallback} from 'react'
import {useMsal} from '@azure/msal-react'
import {ContextoAplicacion} from '../contexto'
import {evaluarPermiso, requiereTipoFacturacion} from './evaluarPermiso'

export const useAutorizacion = () => {
  const {accounts} = useMsal()
  const {infoEmpresa} = useContext(ContextoAplicacion)
  const rol = accounts[0]?.idTokenClaims?.country ?? ''
  const tipoFacturacion = infoEmpresa?.tipoFacturacion ?? ''

  const puedeAcceder = useCallback(
    (modulo) => evaluarPermiso({modulo, rol, tipoFacturacion}),
    [rol, tipoFacturacion],
  )

  const autorizacionLista = useCallback(
    (modulo) => !requiereTipoFacturacion(modulo) || Boolean(tipoFacturacion),
    [tipoFacturacion],
  )

  return {rol, tipoFacturacion, puedeAcceder, autorizacionLista}
}
